import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';

import { Maybe } from '../../shared/types/graphql-types';

import styles from './minimum-price-message.scss';

interface MinimumPriceMessageProps {
  className?: string;
  message?: Maybe<string>;
}

function MinimumPriceMessage(props: MinimumPriceMessageProps) {
  const { className = '', message } = props;

  return (
    <Typography
      className={cn(styles['message'], `${className} minimum-price-message`)}
      size="small"
      weight="bold"
    >
      {message}
    </Typography>
  );
}

export default MinimumPriceMessage;
